import { render } from "./BlockFiles.vue?vue&type=template&id=59e28db4&scoped=true"
import script from "./BlockFiles.vue?vue&type=script&lang=js"
export * from "./BlockFiles.vue?vue&type=script&lang=js"

import "./BlockFiles.vue?vue&type=style&index=0&id=59e28db4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59e28db4"

export default script